{
  "metadata": {
    "anno_riferimento": 2026,
    "data_ultimo_aggiornamento": "2026-08-07",
    "fonte": "artt. 54, 54-ter, 54-quinquies, 54-sexies, 54-septies, 66, 95, 102, 108, 109, 164 TUIR; D.Lgs. 192/2024; L. 207/2024 art. 1 c. 81-83; D.L. 84/2025 conv. L. 108/2025; Circolare AdE 15/E del 22/12/2025; artt. 19 e 19-bis1 DPR 633/1972 (IVA); dettaglio e verifiche in docs/costi-deducibili-piva-teoria-fiscale.md"
  },
  "tipi_contribuente": {
    "professionista": ["INPS_GS", "CASSA_FORENSE", "INARCASSA", "ENPAM", "ENPACL", "CNPADC", "CNPR", "CIPAG", "ENPAP", "ENPAV", "ENPAB", "EPAP", "EPPI", "ENPAPI"],
    "impresa": ["INPS_ART", "INPS_COM"],
    "agente": ["ENASARCO_MONO", "ENASARCO_PLURI"]
  },
  "plafond": {
    "vitto_prof": {
      "base": "ricavi",
      "aliquota_pct": 2,
      "label": "2% dei compensi incassati",
      "norma": "art. 54-septies c. 1 TUIR"
    },
    "rappr_prof": {
      "base": "ricavi",
      "aliquota_pct": 1,
      "label": "1% dei compensi incassati",
      "norma": "art. 54-septies c. 2 TUIR"
    },
    "rappr_impresa": {
      "base": "ricavi",
      "scaglioni_pct": [[10000000, 1.5], [50000000, 0.6], [null, 0.4]],
      "label": "1,5% dei ricavi (fino a 10 milioni)",
      "norma": "art. 108 c. 2 TUIR"
    }
  },
  "gruppi": [
    { "id": "veicoli", "label": "Auto e trasporti", "icona": "ph-car" },
    { "id": "lavoro_trasferte", "label": "Trasferte, formazione e collaboratori", "icona": "ph-suitcase" },
    { "id": "sede", "label": "Studio, negozio o casa", "icona": "ph-buildings" },
    { "id": "beni_tecnologia", "label": "Beni strumentali e tecnologia", "icona": "ph-laptop" },
    { "id": "servizi", "label": "Servizi e consulenze", "icona": "ph-briefcase" },
    { "id": "altro", "label": "Rappresentanza e altre spese", "icona": "ph-gift" }
  ],
  "categorie": [
    {
      "id": "auto_acquisto",
      "gruppo": "veicoli",
      "label": "Acquisto o leasing auto (quota annua)",
      "hint": "La quota di quest'anno, non il prezzo pieno",
      "regole": {
        "professionista": { "pct": 20, "tetto_base": 4519 },
        "impresa": { "pct": 20, "tetto_base": 4519 },
        "agente": { "pct": 80, "tetto_base": 6455.71 }
      },
      "iva": {
        "aliquota_pct": 22,
        "quota_detraibile_pct": { "professionista": 40, "impresa": 40, "agente": 100 },
        "nota": "IVA detraibile al 40% per l'uso promiscuo, al 100% per gli agenti (deroga UE prorogata al 2028)"
      },
      "nota": "Il tetto di legge (18.075,99 € sul costo del veicolo, 25.822,84 € per gli agenti) equivale, con l'ammortamento in 4 anni, a una quota annua massima di 4.519 € (6.455,71 € agenti). Per i professionisti conta un solo veicolo.",
      "norma": "art. 164 c. 1 lett. b TUIR; DM 31/12/1988 (coefficiente 25%)"
    },
    {
      "id": "auto_noleggio",
      "gruppo": "veicoli",
      "label": "Noleggio auto (canoni annui)",
      "regole": {
        "professionista": { "pct": 20, "tetto_base": 3615.2 },
        "impresa": { "pct": 20, "tetto_base": 3615.2 },
        "agente": { "pct": 80, "tetto_base": 5164.57 }
      },
      "iva": {
        "aliquota_pct": 22,
        "quota_detraibile_pct": { "professionista": 40, "impresa": 40, "agente": 100 }
      },
      "nota": "Il tetto vale per il solo canone di noleggio, ragguagliato ad anno; i servizi del full service ne restano fuori se indicati a parte in fattura.",
      "norma": "art. 164 c. 1 lett. b TUIR"
    },
    {
      "id": "auto_impiego",
      "gruppo": "veicoli",
      "label": "Carburante e spese auto (assicurazione, bollo, manutenzione, pedaggi)",
      "regole": {
        "professionista": { "pct": 20 },
        "impresa": { "pct": 20 },
        "agente": { "pct": 80 }
      },
      "iva": {
        "aliquota_pct": 22,
        "quota_detraibile_pct": { "professionista": 40, "impresa": 40, "agente": 100 }
      },
      "avvertenza": "Il carburante è deducibile solo se pagato con carta o altri mezzi tracciabili e documentato da fattura elettronica.",
      "norma": "art. 164 c. 1 TUIR",
      "nota": "Le spese di impiego seguono la percentuale del veicolo, senza tetto."
    },
    {
      "id": "vitto_alloggio",
      "gruppo": "lavoro_trasferte",
      "label": "Ristoranti e hotel (vitto e alloggio)",
      "regole": {
        "professionista": { "pct": 75, "plafond": "vitto_prof" },
        "impresa": { "pct": 75 },
        "agente": { "pct": 75 }
      },
      "iva": {
        "aliquota_pct": 10,
        "quota_detraibile_pct": 100,
        "nota": "IVA detraibile solo se chiedi la fattura: senza fattura l'IVA non è detraibile"
      },
      "avvertenza": "Dal 2025, se sostenute in Italia, deducibili solo se pagate con mezzi tracciabili. Non inserire le spese riaddebitate al committente: sono neutre.",
      "norma": "art. 54-septies c. 1; art. 109 c. 5 TUIR"
    },
    {
      "id": "formazione",
      "gruppo": "lavoro_trasferte",
      "label": "Formazione e aggiornamento (corsi, master, convegni)",
      "regole": {
        "professionista": { "pct": 100, "tetto_base": 10000 },
        "impresa": { "pct": 100 },
        "agente": { "pct": 100 }
      },
      "iva": { "aliquota_pct": 22, "quota_detraibile_pct": 100 },
      "nota": "Per i professionisti include anche viaggio e soggiorno legati alla formazione (pagati con mezzi tracciabili). Per le imprese qui va il solo corso: vitto e alloggio in trasferta restano al 75% e vanno nella riga dedicata.",
      "norma": "art. 54-septies c. 3; art. 109 c. 5 TUIR"
    },
    {
      "id": "lavoro_dipendenti",
      "gruppo": "lavoro_trasferte",
      "label": "Dipendenti e collaboratori (retribuzioni e contributi)",
      "regole": {
        "professionista": { "pct": 100 },
        "impresa": { "pct": 100 },
        "agente": { "pct": 100 }
      },
      "norma": "art. 95 TUIR; art. 54-septies c. 5"
    },
    {
      "id": "affitto_sede",
      "gruppo": "sede",
      "label": "Affitto di studio, ufficio o negozio (uso esclusivo)",
      "regole": {
        "professionista": { "pct": 100 },
        "impresa": { "pct": 100 },
        "agente": { "pct": 100 }
      },
      "norma": "artt. 54 / 109 TUIR (inerenza)"
    },
    {
      "id": "utenze_sede",
      "gruppo": "sede",
      "label": "Utenze della sede esclusiva (luce, gas, acqua, internet)",
      "regole": {
        "professionista": { "pct": 100 },
        "impresa": { "pct": 100 },
        "agente": { "pct": 100 }
      },
      "iva": { "aliquota_pct": 22, "quota_detraibile_pct": 100 },
      "norma": "artt. 54 / 109 TUIR (inerenza)"
    },
    {
      "id": "casa_uso_promiscuo",
      "gruppo": "sede",
      "label": "Casa usata anche come studio (canone o rendita + utenze)",
      "hint": "Canone annuo o rendita catastale, più le utenze: il 50% lo calcoliamo noi",
      "regole": {
        "professionista": { "pct": 50 },
        "impresa": { "pct": 50 },
        "agente": { "pct": 50 }
      },
      "avvertenza": "Professionisti: vale se nello stesso comune non hai un altro immobile a uso esclusivo. Imprese: vale se non hai alcun altro immobile a uso esclusivo dell'attività. L'IVA su queste spese non è detraibile.",
      "norma": "art. 54-quinquies c. 3; art. 64 c. 2 TUIR"
    },
    {
      "id": "telefonia",
      "gruppo": "beni_tecnologia",
      "label": "Telefono e connettività (fisso, mobile, traffico)",
      "regole": {
        "professionista": { "pct": 80 },
        "impresa": { "pct": 80 },
        "agente": { "pct": 80 }
      },
      "iva": {
        "aliquota_pct": 22,
        "quota_detraibile_pct": 50,
        "nota": "IVA detraibile secondo l'uso effettivo: il 50% è la prassi prudente per l'uso promiscuo"
      },
      "norma": "art. 54-quinquies c. 4; art. 102 c. 9 TUIR"
    },
    {
      "id": "beni_sotto_516",
      "gruppo": "beni_tecnologia",
      "label": "Attrezzatura e beni fino a 516 € l'uno",
      "regole": {
        "professionista": { "pct": 100 },
        "impresa": { "pct": 100 },
        "agente": { "pct": 100 }
      },
      "iva": { "aliquota_pct": 22, "quota_detraibile_pct": 100 },
      "nota": "Sotto questa soglia il costo si deduce tutto nell'anno, senza ammortamento.",
      "norma": "art. 54-quinquies c. 1; art. 102 c. 5 TUIR"
    },
    {
      "id": "ammortamenti_quota",
      "gruppo": "beni_tecnologia",
      "label": "Quote di ammortamento dei beni oltre 516 € (quota annua)",
      "hint": "Es. computer da 2.000 €: quota annua 400 € (coefficiente 20%)",
      "regole": {
        "professionista": { "pct": 100 },
        "impresa": { "pct": 100 },
        "agente": { "pct": 100 }
      },
      "nota": "Coefficienti tipici: computer e macchine elettroniche 20%, mobili e arredi 12%. L'IVA si detrae per intero all'acquisto.",
      "norma": "art. 54-quinquies c. 1; art. 102 TUIR; DM 31/12/1988"
    },
    {
      "id": "beni_promiscui",
      "gruppo": "beni_tecnologia",
      "label": "Beni usati anche privatamente (PC, tablet, arredi promiscui)",
      "regole": {
        "professionista": { "pct": 50 },
        "impresa": { "pct": 50 },
        "agente": { "pct": 50 }
      },
      "nota": "Beni a uso promiscuo lavoro/privato, esclusi i veicoli (hanno le loro righe). L'IVA si detrae solo per la quota d'uso professionale documentabile: prudenzialmente non la stimiamo.",
      "norma": "art. 54-quinquies c. 3; art. 64 c. 2 TUIR"
    },
    {
      "id": "software",
      "gruppo": "beni_tecnologia",
      "label": "Software e abbonamenti digitali",
      "regole": {
        "professionista": { "pct": 100 },
        "impresa": { "pct": 100 },
        "agente": { "pct": 100 }
      },
      "iva": { "aliquota_pct": 22, "quota_detraibile_pct": 100 },
      "nota": "Le licenze pluriennali si deducono in quote sulla durata del contratto.",
      "norma": "art. 54-sexies c. 2; art. 103 TUIR"
    },
    {
      "id": "consulenze",
      "gruppo": "servizi",
      "label": "Consulenze (commercialista, legali, notaio)",
      "regole": {
        "professionista": { "pct": 100 },
        "impresa": { "pct": 100 },
        "agente": { "pct": 100 }
      },
      "iva": { "aliquota_pct": 22, "quota_detraibile_pct": 100 },
      "norma": "artt. 54 / 109 TUIR (inerenza)"
    },
    {
      "id": "pubblicita",
      "gruppo": "servizi",
      "label": "Pubblicità e marketing (sito, campagne, inserzioni)",
      "regole": {
        "professionista": { "pct": 100 },
        "impresa": { "pct": 100 },
        "agente": { "pct": 100 }
      },
      "iva": { "aliquota_pct": 22, "quota_detraibile_pct": 100 },
      "norma": "art. 108 c. 1 TUIR; artt. 54 / 109 (inerenza)"
    },
    {
      "id": "assicurazioni",
      "gruppo": "servizi",
      "label": "Assicurazioni professionali (RC, tutela legale, crediti)",
      "regole": {
        "professionista": { "pct": 100 },
        "impresa": { "pct": 100 },
        "agente": { "pct": 100 }
      },
      "nota": "I premi assicurativi sono esenti IVA.",
      "norma": "artt. 54 / 109 TUIR; art. 54-septies c. 4"
    },
    {
      "id": "spese_bancarie_interessi",
      "gruppo": "servizi",
      "label": "Spese bancarie e interessi passivi inerenti",
      "regole": {
        "professionista": { "pct": 100 },
        "impresa": { "pct": 100 },
        "agente": { "pct": 100 }
      },
      "nota": "Gli interessi su ritardati versamenti di imposte non sono deducibili.",
      "norma": "art. 54 c. 1; art. 61 TUIR"
    },
    {
      "id": "rappresentanza",
      "gruppo": "altro",
      "label": "Spese di rappresentanza (cene e ospitalità offerte a clienti)",
      "regole": {
        "professionista": { "pct": 75, "plafond": "rappr_prof" },
        "impresa": { "pct": 75, "plafond": "rappr_impresa" },
        "agente": { "pct": 75, "plafond": "rappr_impresa" }
      },
      "nota": "Doppio limite: le cene e l'ospitalità si riducono prima al 75% (come vitto e alloggio), poi l'importo ridotto entra nel plafond. Le spese di rappresentanza non alimentari sarebbero al 100% entro lo stesso plafond: inserirle qui produce una stima prudente.",
      "avvertenza": "Dal 2025 deducibili solo se pagate con mezzi tracciabili. L'IVA su queste spese non è detraibile.",
      "norma": "art. 54-septies c. 2; art. 108 c. 2 TUIR; Circ. AdE 53/E/2008 e 34/E/2009"
    },
    {
      "id": "omaggi_50",
      "gruppo": "altro",
      "label": "Omaggi a clienti fino a 50 € l'uno",
      "regole": {
        "professionista": { "pct": 100, "plafond": "rappr_prof" },
        "impresa": { "pct": 100 },
        "agente": { "pct": 100 }
      },
      "iva": { "aliquota_pct": 22, "quota_detraibile_pct": 100 },
      "nota": "Per le imprese gli omaggi entro 50 € sono interamente deducibili, fuori dal plafond di rappresentanza.",
      "norma": "art. 108 c. 2 TUIR; art. 19-bis1 lett. h DPR 633/1972"
    },
    {
      "id": "merci",
      "gruppo": "altro",
      "label": "Merci e materie prime",
      "solo": ["impresa", "agente"],
      "regole": {
        "impresa": { "pct": 100 },
        "agente": { "pct": 100 }
      },
      "iva": { "aliquota_pct": 22, "quota_detraibile_pct": 100 },
      "nota": "In contabilità semplificata si deducono quando le paghi; le rimanenze non contano.",
      "norma": "art. 66 TUIR"
    },
    {
      "id": "cancelleria_materiali",
      "gruppo": "altro",
      "label": "Cancelleria, materiali di consumo, libri professionali",
      "regole": {
        "professionista": { "pct": 100 },
        "impresa": { "pct": 100 },
        "agente": { "pct": 100 }
      },
      "iva": { "aliquota_pct": 22, "quota_detraibile_pct": 100 },
      "norma": "artt. 54 / 109 TUIR (inerenza)"
    },
    {
      "id": "compensi_familiari",
      "gruppo": "altro",
      "label": "Compensi a coniuge, figli minorenni o inabili, genitori",
      "regole": {
        "professionista": { "pct": 0 },
        "impresa": { "pct": 0 },
        "agente": { "pct": 0 }
      },
      "nota": "Non sono deducibili (in cambio non sono tassati per chi li riceve). Sono invece deducibili i compensi ai figli maggiorenni abili al lavoro e le prestazioni fatturate dal familiare con la propria partita IVA: quelle vanno tra le altre categorie.",
      "norma": "art. 54-septies c. 6; art. 60 TUIR; C.M. 137/E/1997"
    }
  ]
}
